import getClientId from './ClientId'
import Encryption from './Encryption';

const metadata = async (params:object) =>  {
  let userInfo: any = window.localStorage.getItem('userInfo')
  if (userInfo === undefined || userInfo === 'undefined') {
    userInfo =JSON.stringify({token: ''});
  }
  let token = JSON.parse(userInfo).token
  let info =  Encryption.decayFun(token, 'NgAbCJJGfUlQ6653');
  // @ts-ignore
   let uid = info ? JSON.parse(info).id : ''
  let roomId = '';
   if (window.localStorage.getItem('activeRoom')) {
     roomId = JSON.parse(window.localStorage.getItem('activeRoom') || '{}').id
   }
  let data = {
    ...params,
    cookieId: window.localStorage.getItem('clientId') || await getClientId(),
    resolution: window.screen.availWidth + 'x' + window.screen.availHeight ,
    userId: uid,
    channel: window.localStorage.getItem('channel') || '',
    roomId,
  }
  return Encryption.encryptFun(JSON.stringify(data), 'NgAbCJJGfUlQ6653')
}

const log = (params: object) => {
  (async () => {
    console.log(params)
    let parmeterData = await metadata(params);
    return fetch('/log/api/track/report', {
      method: 'POST',
      body: parmeterData,
      headers: new Headers({
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      })
    })
  })()
}

export default log;
